import { ReservationGroup } from '@mews-commander/data-access';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useGetAllReservationGroupsQuery = (ids: string[]): ReservationGroup[] => {
    // TODO: use this in follow up task when BE endpoint is ready
    // const { data } = useRepositoryQuery(
    //     'reservationGroups',
    //     'getAll',
    //     { ids },
    //     {
    //         enabled: !!ids.length,
    //         select: (result) => result.reservationGroups || [],
    //     }
    // );

    return [];
};
